import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { from } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import * as MenusActionTypes from '../../actions/menus/menu.actions';
import * as MessagesActionTypes from '../../actions/messages/message.actions';
import { CardsService } from '../../../shared/services/cards/cards.service';
import { AppState } from '../../reducers';
import { MenuService } from 'src/app/shared/services/menu/menu.service';


@Injectable()
export class MenusEffects {

    constructor(
        private actions$: Actions,
        private store$: Store<AppState>,
        private router: Router,
        private cardService: CardsService,
        private translate: TranslateService,
        private menuService: MenuService
 
    ) { }

    getMenus$ = createEffect(() =>
        this.actions$
            .pipe(
                ofType(MenusActionTypes.getMenus),
                exhaustMap((action) => this.menuService.getMenus()
                    .pipe(
                        map(result => MenusActionTypes.loadMenus({ response: result })),
                        catchError((error) => {
                            const actions = [
                                MenusActionTypes.setLoadingEndState(),
                                MessagesActionTypes.setMessage(
                                    {
                                        appMessage:
                                        {
                                            key: 'error',
                                            message: this.translate.instant('App.Errors.Error'),
                                            owner: 'Menu',
                                            severity: 'error',
                                            timestamp: new Date().getTime()
                                        }
                                    }
                                )
                            ];
                            return from(actions);
                        }
                        )
                    )
                )
            )
    );
 

}